import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { catchError, map, find } from 'rxjs/operators';
import { ConfigStateService } from '@abp/ng.core';
import { Constants } from 'src/app/warr/common/constants';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private configStateService: ConfigStateService,
    private router: Router
  ) {}
  private lastUrlChecked: string | null = null;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (state.url === this.lastUrlChecked) {
      return of(true); // đã check URL này rồi, skip
    }
    this.lastUrlChecked = state.url;
    // console.warn('Guard called for path:', state.url);
    // console.warn('Route data:', route.data);
    // 👉 logic của bạn
    // if (this.oauthService.hasValidAccessToken()) {
    let accessToken = localStorage.getItem('access_token');
    let expiresIn = localStorage.getItem('expires_in');
    if (!accessToken) {
      return this.refreshToken();
    }
    return this.introspectToken(accessToken);
  }
  private refreshToken(): Observable<boolean> {
    return this.authService.refreshToken().pipe(
      map(newUser => {
        if (!newUser) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('expires_in');
          localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);

          // window.location.reload();
          // this.router.navigate(['/auth/login']);
          this.authService.reloadConfig().subscribe(res => {
            return false;
          });
          return false;
        }
        let accessToken = newUser.accessToken;
        let objectAuth = this.authService.decodejwt(accessToken);
        if (!objectAuth || !objectAuth['portal_user_id']) {
          confirm(
            'Tài khoản của bạn chưa được phân quyền truy cập hệ thống. Vui lòng liên hệ Quản trị viên.'
          );
          localStorage.removeItem('access_token');
          localStorage.removeItem('expires_in');
          localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);
          this.authService.logout(accessToken).subscribe();
          this.router.navigate(['/']);
          return;
        }
        this.authService.reloadConfig().subscribe(res => {
          if (localStorage.getItem(Constants.LocalKey.IsCasperEmployee) == null) {
            this.router.navigate(['/']);
          }
          return true;
        });
      }),
      catchError(err => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);

        // window.location.reload();
        // this.router.navigate(['/auth/login']);
        this.authService.reloadConfig().subscribe(res => {
          return false;
        });
        return of(false);
      })
    );
  }
  private introspectToken(token: string): Observable<boolean> {
    return this.authService.introspectToken(token).pipe(
      map(isActive => {
        let accessToken = localStorage.getItem('access_token')!;
        if (!isActive) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('expires_in');
          localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);

          window.location.reload();
          // this.router.navigate(['/auth/login']);
          this.authService.logout(accessToken).subscribe();
          return false;
        }

        let objectAuth = this.authService.decodejwt(accessToken);
        if (!objectAuth || !objectAuth['portal_user_id']) {
          confirm(
            'Tài khoản của bạn chưa được phân quyền truy cập hệ thống. Vui lòng liên hệ Quản trị viên.'
          );
          localStorage.removeItem('access_token');
          localStorage.removeItem('expires_in');
          localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);
          this.authService.logout(accessToken).subscribe();
          this.router.navigate(['/']);
          return;
        }
        this.authService.reloadConfig().subscribe(res => {
          if (localStorage.getItem(Constants.LocalKey.IsCasperEmployee) == null) {
            this.router.navigate(['/']);
          }
          return true;
        });
        return true;
      }),
      catchError(err => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_in');
        localStorage.removeItem(Constants.LocalKey.IsCasperEmployee);

        window.location.reload();

        return of(false);
      })
    );
  }
}
